import type { Action } from 'redux'
import { combineReducers } from 'redux'

import { CLOSE_STORE_DETAILS, OPEN_STORE_DETAILS } from './constants'

interface ReducerAction extends Action {
  payload: {
    storeId: number
    countryId: string
  }
}

const storeId = (state = null, action: ReducerAction) => {
  switch (action.type) {
    case OPEN_STORE_DETAILS:
      return action.payload.storeId

    case CLOSE_STORE_DETAILS:
      return null

    default:
      return state
  }
}

const countryId = (state = null, action: ReducerAction) => {
  switch (action.type) {
    case OPEN_STORE_DETAILS:
      return action.payload.countryId

    case CLOSE_STORE_DETAILS:
      return null

    default:
      return state
  }
}

const isOpen = (state = false, action: ReducerAction) => {
  switch (action.type) {
    case OPEN_STORE_DETAILS:
      return true

    case CLOSE_STORE_DETAILS:
      return false

    default:
      return state
  }
}

export default combineReducers({
  countryId,
  storeId,
  isOpen,
})
